namespace $.$$ {

	$mol_style_define( $shm_tests_player, {

		width: '100%',

		Workspace: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.block,
			width: '100%',
			align: {
				items: 'flex-start',
			},
		},

		Main: {
			flex: {
				direction: 'column',
				grow: 1,
				basis: '40rem',
			},
			minWidth: 0,
			gap: $mol_gap.text,
		},

		Video: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			width: '100%',
			height: 'auto',
			background: {
				color: 'black',
			},
		},

		Controls: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.text,
			align: {
				items: 'center',
			},
		},

		Time: {
			padding: $mol_gap.text,
		},

		Current: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
		},

		Current_benchmarks: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
		},

		Current_media: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
		},

		Current_screenshot: {
			maxWidth: '100%',
			maxHeight: '32rem',
			objectFit: 'contain',
		},

	} )

}
